import { render, staticRenderFns } from "./SelectPrimaryBackupDealControl.vue?vue&type=template&id=7396cac5&scoped=true"
import script from "./SelectPrimaryBackupDealControl.vue?vue&type=script&lang=js"
export * from "./SelectPrimaryBackupDealControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7396cac5",
  null
  
)

export default component.exports